<template>
  <div>
    <div class="row">
      <div class="col-md-12 header-row">
        <h3 class="heading semi-bold">Status Log for {{ fabric.name }}</h3>
        <div class="row">
          <div class="col-md-3">
            <label>Date From</label>
            <datepicker
              :clear-button="true"
              placeholder="Date From"
              v-model="dateFrom"
              input-class="form-control"
            >
            </datepicker>
          </div>
          <div class="col-md-3">
            <label>Date To</label>
            <datepicker
              :clear-button="true"
              placeholder="Date To"
              v-model="dateTo"
              input-class="form-control"
            >
            </datepicker>
          </div>
          <div class="col-md-2">
            <label>Timezone</label>
            <v-select
              :options="timezones"
              v-model="selectedTimezone"
            ></v-select>
          </div>
        </div>
      </div>
    </div>

    <!-- table -->
    <div class="row">
      <div class="col-md-12">
        <div
          class="grid bg-white added-margin shadow"
          style="padding-top: 20px"
        >
          <div class="grid-title">
            <h4>
              Total - {{ totalRows }} Row<span v-if="rows.length > 1">s</span>
            </h4>
          </div>
          <div class="grid-body">
            <vue-good-table
              mode="remote"
              @on-page-change="onPageChange"
              @on-per-page-change="onPerPageChange"
              :totalRows="totalRows"
              styleClass="table table-bordered"
              :isLoading.sync="isLoading"
              :pagination-options="{
                enabled: true,
                mode: 'pages',
              }"
              :columns="columns"
              :rows="rows"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'old_status'">
                  <span
                    :class="
                      'badge badge-' + getStatusColor(props.row.old_status)
                    "
                  >
                    {{ props.row.old_status.replace(/_/g, " ") }}
                  </span>
                </span>
                <span v-else-if="props.column.field == 'new_status'">
                  <span
                    :class="
                      'badge badge-' + getStatusColor(props.row.new_status)
                    "
                  >
                    {{ props.row.new_status.replace(/_/g, " ") }}
                  </span>
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import { VueGoodTable } from "vue-good-table";
import Fabric from "@/pages/Tools/Fabric";
import fabricColumns from "./tools/fabricColumns";

export default {
  mounted() {
    this.getFabricBaseData();
    this.dateTo = new Date(new moment().endOf("month"));
    this.dateFrom = new Date(new moment().startOf("month"));
    this.selectedTimezone = this.timezones.filter((tz) => tz.value == "UTC")[0];
    this.getFabricStatusLogs();
  },
  components: {
    VueGoodTable,
    Datepicker,
  },
  data: () => ({
    columns: [
      {
        label: "Log ID",
        field: "id",
        tdClass: "text-center",
        thClass: "text-center",
        sortable: false,
      },
      {
        label: "Old Status",
        field: "old_status",
        tdClass: "text-center col-sm-2",
        thClass: "text-center",
        sortable: false,
      },
      {
        label: "New Status",
        field: "new_status",
        tdClass: "text-center col-sm-2",
        thClass: "text-center",
        sortable: false,
      },
      {
        label: "Old Note",
        field: "old_note",
        tdClass: "text-center col-sm-2",
        thClass: "text-center",
        sortable: false,
      },
      {
        label: "New Note",
        field: "new_note",
        tdClass: "text-center col-sm-2",
        thClass: "text-center",
        sortable: false,
      },
      {
        label: "Free Stock",
        field: "free_stock_text",
        tdClass: "text-center",
        thClass: "text-center",
        sortable: false,
      },
      {
        label: "Reserved Stock",
        field: "reserved_stock_text",
        tdClass: "text-center",
        thClass: "text-center",
        sortable: false,
      },
      {
        label: "Future",
        field: "future",
        tdClass: "text-center",
        thClass: "text-center",
        sortable: false,
      },
      {
        label: "Average Usage",
        field: "average_usage_text",
        tdClass: "text-center",
        thClass: "text-center",
        sortable: false,
      },
      {
        label: "Type",
        field: "type",
        tdClass: "text-center",
        thClass: "text-center",
        sortable: false,
      },
      {
        label: "Reason",
        field: "reason",
        tdClass: "text-center",
        thClass: "text-center col-sm-3",
        sortable: false,
      },
      {
        label: "Date",
        field: "created_at_text",
        tdClass: "text-left col-sm-2",
        thClass: "text-left",
        sortable: false,
      },
    ],
    timezones: [
      { value: "UTC", label: "Server Time" },
      { value: "Europe/Berlin", label: "Germany" },
      { value: "Asia/Bangkok", label: "Thailand" },
    ],
    isLoading: false,
    fabric: {},
    dateFrom: null,
    dateTo: null,
    selectedTimezone: null,
    rows: [],
    totalRows: 0,
    serverParams: {
      totalPages: 1,
      page: 1,
      perPage: 10,
    },
  }),
  methods: {
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    async getFabricBaseData() {
      try {
        let results = await axios({
          method: "get",
          url: `/v2/fabrics/${this.$route.params.id}/edit`,
        });
        this.fabric = results.data.data.fabric;
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          this.$router.push("/404");
        }
      }
    },
    getStatusColor(status) {
      if (["available"].includes(status)) {
        return "primary";
      } else if (
        ["soon_sold_out_not_coming_back", "soon_sold_out_coming_back"].includes(
          status
        )
      ) {
        return "warning";
      } else {
        return "danger";
      }
    },
    async getFabricStatusLogs() {
      let params =
        "from=" +
        moment(this.dateFrom).format("YYYY-MM-DD") +
        "&to=" +
        moment(this.dateTo).format("YYYY-MM-DD") +
        "&fabric_id=" +
        this.$route.params.id +
        "&page=" +
        this.serverParams.page +
        "&rows_per_page=" +
        this.serverParams.perPage +
        "&timezone=" +
        this.selectedTimezone.value;

      try {
        let res = await axios.get("/v2/fabrics/status_logs?" + params);
        this.rows = res.data.data;
        this.totalRows = res.data.meta.total;
        this.updateParams({
          page: res.data.meta.current_page,
          totalPages: res.data.meta.last_page,
        });
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },
    async onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      await this.getFabricStatusLogs();
    },
    async onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      await this.getFabricStatusLogs();
    },
  },
  watch: {
    async dateFrom() {
      if (this.dateTo) {
        await this.getFabricStatusLogs();
      }
    },
    async dateTo() {
      if (this.dateFrom) {
        await this.getFabricStatusLogs();
      }
    },
    async selectedTimezone() {
      if (this.selectedTimezone !== null) {
        this.updateParams({ page: 1 });
        await this.getFabricStatusLogs();
      }
    },
  },
};
</script>

<style scoped>
@import "~sweetalert2/dist/sweetalert2.min.css";
@import "~vue-good-table/dist/vue-good-table.css";

.grid-body {
  overflow-x: auto !important;
}

.header-row {
  margin-bottom: 20px;
}

.header-row .search-fabric {
  height: 38px;
}

.form-control {
  height: 38px;
}
.input-group-addon {
  height: 38px !important;
}
.img {
  height: 40px;
  width: 40px;
  border-radius: 5px;
}
.tiles-title {
  font-size: 14px;
  color: #4f5458;
  font-weight: bold;
}
hr {
  border-bottom: 0.02px solid #e6e6e6 !important;
  margin: 10px 0px 0px 0px !important;
}
.dropdown-menu {
  right: 0;
  left: auto;
  padding-left: 1px;
  padding-right: 1px;
  border: 1px solid #27a699;
}
.up-par {
  background: #f1f1f1;
}
.time-frame {
  margin-top: -33px !important;
  margin-bottom: 0px !important;
  float: right;
}

.table-div {
  overflow: scroll;
  height: 600px;
}
.table tr th {
  position: sticky !important;
  top: -1px;
  text-align: center;
}
</style>
